(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-winter-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaWinterBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-wbar]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-wbar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-wbar-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-wbar-countdown], [data-aa-wbar-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaWinterBarInit();
document.addEventListener('shopify:section:load', aaWinterBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
